import React, { useContext, useRef } from 'react';
import { AppBar, Toolbar, Box } from '@mui/material';
import Header from '../../components/header/Header';
import { ThemeContext } from '../../context/ThemeContext';
import Datamanager from '../../components/global/DataManager/Datamanager';
import AccountFooter from '../../components/footer/AccountFooter';
import { WebSocketProvider } from '../../context/WebSocketContext';

const LayoutWrapper = ({ children, openOneClickModal, closeOneClickModal, toggleSymbolPanel, isSymbolPanelVisible, handleOpenOneTradeModal, currentSymbolId, handleOpenNewDashboard }) => {
  const { darkMode } = useContext(ThemeContext)
  const containerRef = useRef(null);

  const disableContextMenu = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Box ref={containerRef} sx={{ display: 'flex' }} onContextMenu={disableContextMenu}>
        <AppBar position="fixed" sx={{ height: '44px', ".MuiToolbar-root": { minHeight: "44px !important", padding: '0 !important' }, }}>
          <Toolbar><Header isSymbolPanelVisible={isSymbolPanelVisible} toggleSymbolPanel={toggleSymbolPanel} containerRef={containerRef} openOneClickModal={openOneClickModal} closeOneClickModal={closeOneClickModal} handleOpenOneTradeModal={handleOpenOneTradeModal} currentSymbolId={currentSymbolId} handleOpenNewDashboard={handleOpenNewDashboard} /></Toolbar>
        </AppBar>
        <Box component="main" sx={{ flexGrow: 1, bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', mt: '44px', }}>{children}</Box>
        <Datamanager />
        <WebSocketProvider></WebSocketProvider>
      </Box>
      {/* <Box sx={{height:30}}>
        <AccountFooter />
      </Box> */}
    </>
  );
};

export default LayoutWrapper;
